module.exports = __webpack_public_path__ + "static/media/icon-pate-a-modeler.19be8266.svg";